import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import BugForm from '@/components/BugForm';
import DistributionForm from '@/components/DistributionForm';
import Login from '@/components/Login';
import ProductRequestForm from '@/components/ProductRequestForm';
import OptionsDashboard from '@/components/reports/options/OptionsDashboard';
import IndustryDashboard from '@/components/reports/industry/IndustryDashboard';
import SalesFunnel from '@/components/reports/leads/SalesFunnel';
import { store } from '@/store/index';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/bugs',
      name: 'BugForm',
      component: BugForm
    },
    {
      path: '/product-request',
      name: 'ProductRequestForm',
      component: ProductRequestForm
    },
    {
      path: '/options-dashboard',
      name: 'OptionsDashboard',
      component: OptionsDashboard,
      beforeEnter: requireAdminStatus
    },
    {
      path: '/industry-dashboard',
      name: 'IndustryDashboard',
      component: IndustryDashboard,
      beforeEnter: requireAdminStatus
    },
    {
      path: '/sales-funnel',
      name: 'SalesFunnel',
      component: SalesFunnel,
      beforeEnter: requireAdminStatus
    },
    {
      path: '/distribution-cutoff',
      name: 'DistributionForm',
      component: DistributionForm,
      beforeEnter: requireAdminStatus
    }
  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  next();
});

function requireAdminStatus(to, from, next) {
  const isAdmin = store.getters['account/isAdmin'];

  if (!isAdmin) {
    return next('/');
  }

  next();
}



// WEBPACK FOOTER //
// ./src/router/index.js